import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { ConditionalSessionProvider } from './components/ConditionalSessionProvider';
import App from './App';

try {
  const existingCount = sessionStorage.getItem('playmerce_event_count');
  if (existingCount === null) {
    sessionStorage.setItem('playmerce_event_count', '0');
  } else {
    const currentCount = parseInt(existingCount, 10);
    sessionStorage.setItem('playmerce_event_count', (currentCount + 1).toString());
  }
} catch (error) {
  console.warn('Failed to increment playmerce_event_count:', error);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <BrowserRouter>
        <ConditionalSessionProvider>
          <App />
        </ConditionalSessionProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
